import { Box, Button, FormControl, Grid, MenuItem, Select, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { TEXT } from "Clients/ACCB/ACCBTheme";

export default function Report({classes,REPORT_CHOICES,handleClickSearch}){
  const [search, setSearch] = useState('');

  const handleChangeSearchReport = (e) => {
    setSearch(e.target.value);
  }

  return (
    <Box>
      <Box className={classes.entryForm}>
        <Grid container spacing={2} className={classes.reportCard}>
          <Grid item xs={12}>
            <FormControl required fullWidth margin="none" variant="outlined">
              <Typography className={classes.label}>Search Report<span style={{ color: "red" }}>*</span></Typography>
              <Select
                name="search_report"
                value={search}
                onChange={handleChangeSearchReport}
                displayEmpty
                renderValue={(selected) =>
                  selected || <span style={{ color: TEXT.muted }}>Select Report</span>
                }
              >
                {REPORT_CHOICES.map((report,index)=>{
                  return (
                    <MenuItem key={index} value={report}>{report}</MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} className={classes.reportActions}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              // Searching with no report chosen rendered "Invalid Choice"
              disabled={!search}
              onClick={()=>handleClickSearch(search)}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
